var _path, _g, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfirmation1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 72,
    viewBox: "0 0 104 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.1428 28.2857C96.5017 58.4465 71.9294 72 52.5559 72C33.1825 72 8 55.7095 8 38.359C8 21.0086 12.6244 10.2043 32.1126 3.51391C51.6008 -3.1765 91.784 -1.87508 94.1428 28.2857Z",
    fill: "#F7F7FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_113_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.6819 18.8637C37.6819 17.5601 38.7387 16.5033 40.0423 16.5033C48.7464 16.5033 57.4504 16.5034 66.1544 16.5033C67.458 16.5033 68.5148 17.5601 68.5148 18.8638V55.4967C68.5148 56.8003 67.458 57.8571 66.1544 57.8571C57.4504 57.8571 48.7464 57.8571 40.0423 57.8571C38.7387 57.8571 37.6819 56.8003 37.6819 55.4966V18.8637Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3214 16.5033C35.3214 15.1997 36.3782 14.1429 37.6819 14.1429C46.3859 14.1429 55.0899 14.1429 63.7939 14.1429C65.0975 14.1429 66.1544 15.1997 66.1544 16.5033V53.1362C66.1544 54.4399 65.0976 55.4967 63.7939 55.4967C55.0899 55.4967 46.3859 55.4967 37.6819 55.4967C36.3782 55.4967 35.3214 54.4399 35.3214 53.1362V16.5033Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.1238,
    y: 18.7109,
    width: 21.2442,
    height: 2.36046,
    rx: 1.18023,
    fill: "#E6E5FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.0249,
    y: 49.3969,
    width: 17.7035,
    height: 2.36046,
    rx: 1.18023,
    fill: "#E6E5FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.1238,
    y: 23.4318,
    width: 12.9825,
    height: 2.36046,
    rx: 1.18023,
    fill: "#E6E5FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.1063,
    y: 44.676,
    width: 10.6221,
    height: 2.36046,
    rx: 1.18023,
    fill: "#E6E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2684 29.777C57.7293 30.2379 57.7293 30.9852 57.2684 31.4461L49.6953 39.0192C49.4739 39.2406 49.1737 39.3649 48.8607 39.3649C48.5477 39.3649 48.2475 39.2406 48.0262 39.0192L44.5838 35.5769C44.1229 35.116 44.1229 34.3687 44.5838 33.9078C45.0447 33.4469 45.792 33.4469 46.2529 33.9078L48.8607 36.5156L55.5993 29.777C56.0602 29.3161 56.8075 29.3161 57.2684 29.777Z",
    fill: "#8E8CEE"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2759 7.24C10.0039 7.336 9.51591 7.464 8.81191 7.624C8.10791 7.768 7.55591 7.864 7.15591 7.912L6.89191 6.232C7.75591 6.056 8.65191 5.744 9.57991 5.296C10.5239 4.832 11.2919 4.352 11.8839 3.856H11.9079L13.8039 4.12V17.32L16.5399 17.584V19H7.39591V17.584L10.2759 17.344V7.24Z",
    fill: "#8E8CEE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_113_104",
    x: 7.32141,
    y: -11.8571,
    width: 89.1935,
    height: 99.7143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380392 0 0 0 0 0.376471 0 0 0 0 0.635294 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_113_104"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_113_104",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmation1);
export default __webpack_public_path__ + "static/media/confirmation1.03ccf9c59c547260e101b4e87b8bd5f4.svg";
export { ForwardRef as ReactComponent };